// @flow

import { message } from 'antd'
import { getProps } from '../props';
import { reviseEstimate } from '../../../HttpRequests/estimates';
import switchEstimate from './switchEstimate';
import handleException from '../../../Core/Helpers/handleException';

export default ({ revisionReason, revisionNotes }: { revisionReason?: string, revisionNotes?: string } = {}) => async (dispatch: Function) => {

  try {

    const { id } = getProps().match.params;

    const data = {
      revision_reason: revisionReason,
      revision_notes: revisionNotes,
    };

    const response = await reviseEstimate({ id, data });

    const estimate = response.data.data;

    dispatch(switchEstimate(estimate.id))

    message.success('Estimate Revised.');

  } catch (error) {

    handleException(error);

  }
}
